/**
 * Matomo 埋点（见 src/data/matomoCb.md）
 * user_type / page_version 暂未接入业务，先置空字符串。
 */
export const MATOMO_USER_TYPE = '';
export const MATOMO_PAGE_VERSION = '';

export function getMatomoCommonPayload(extra = {}) {
  return {
    // user_type: MATOMO_USER_TYPE,
    page_version: MATOMO_PAGE_VERSION,
    ...extra
  };
}

function safeMatomoCb(...args) {
  if (typeof window !== 'undefined' && typeof window.matomoCb === 'function') {
    window.matomoCb(...args);
  }
}

function trackNamedEvent(eventName, payload) {
  safeMatomoCb(
    'trackEvent',
    'PC端',
    eventName,
    JSON.stringify(getMatomoCommonPayload(payload))
  );
}

/** 列表/标题中 HTML 转纯文本，便于 doc_title */
export function stripHtmlTitle(html) {
  if (html == null || html === '') return '';
  if (typeof html !== 'string') return String(html);
  const div = typeof document !== 'undefined' ? document.createElement('div') : null;
  if (div) {
    div.innerHTML = html;
    return (div.textContent || '').trim().slice(0, 300);
  }
  return html.replace(/<[^>]+>/g, '').trim().slice(0, 300);
}

// —— 首页会话：停留时长、跳出（SPA 在 home 组件销毁时结算）——
let homeLoadTs = 0;
let homeEngaged = false;

export function initHomePageSession() {
  homeLoadTs = Date.now();
  homeEngaged = false;
}

export function markHomePageEngaged() {
  homeEngaged = true;
}

/** 离开首页时调用：上报停留秒数；若全程无点击/搜索则上报 homepage_bounce */
export function flushHomePageLeave() {
  if (homeLoadTs === 0) return;
  const durationSec = Math.max(0, Math.round((Date.now() - homeLoadTs) / 1000));
  trackKnowledgeHomepageVisitDuration(durationSec);
  if (!homeEngaged) {
    trackHomepageBounce();
  }
  homeLoadTs = 0;
  homeEngaged = false;
}

export function trackKnowledgeHomepageView() {
  trackNamedEvent('knowledge_homepage_view', {});
}

export function trackKnowledgeHomepageVisitDuration(duration) {
  trackNamedEvent('knowledge_homepage_visit_duration', {
    duration: typeof duration === 'number' ? duration : parseInt(duration, 10) || 0
  });
}

export function trackSearchBoxExposure() {
  trackNamedEvent('search_box_exposure', { position: 'top' });
}

/** section: company_intro | cloud_security | products_solutions | training_materials */
export function trackCategorySectionExposure(section) {
  trackNamedEvent('category_section_exposure', { section });
}

export function trackCategoryCardClick(category, cardTitle, position) {
  trackNamedEvent('category_card_click', {
    category: String(category || ''),
    card_title: String(cardTitle || ''),
    position: String(position || '')
  });
}

export function trackCategoryContentView(category, contentId, contentTitle) {
  trackNamedEvent('category_content_view', {
    category: String(category || ''),
    content_id: String(contentId || ''),
    content_title: String(contentTitle || '')
  });
}

/** entry_point: category | search | homepage_recommend */
export function trackDocumentClick(docId, docTitle, entryPoint) {
  trackNamedEvent('document_click', {
    doc_id: String(docId || ''),
    doc_title: stripHtmlTitle(docTitle),
    entry_point: String(entryPoint || '')
  });
}

export function trackHomepageBounce() {
  trackNamedEvent('homepage_bounce', {});
}

/** 网格内第几行第几列（1-based），与规范示例一致 */
export function formatCardGridPosition(index, gridCols) {
  const cols = Math.max(1, parseInt(gridCols, 10) || 1);
  const i = Math.max(0, parseInt(index, 10) || 0);
  const row = Math.floor(i / cols) + 1;
  const col = (i % cols) + 1;
  return `第${row}行第${col}列`;
}

/** 首页 Featured 等详情链中的 articleId（相对或绝对 URL） */
export function parseArticleIdFromKbLink(url) {
  if (!url || String(url).indexOf('detailPage') === -1) return null;
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://local';
    const u = url.startsWith('http') ? new URL(url) : new URL(url, base);
    const raw = u.searchParams.get('articleData');
    if (!raw) return null;
    const parsed = JSON.parse(decodeURIComponent(raw));
    return parsed.articleId != null ? String(parsed.articleId) : null;
  } catch (e) {
    return null;
  }
}
